import { TextField } from "@mui/material";

const PinForm = ({ formik, confirmPin, setConfirmPin }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <div className="w-full">
        <TextField
          fullWidth
          autoComplete="off"
          type="password"
          placeholder="PIN"
          label="PIN"
          value={
            formik.values.data.pin === 0
              ? ""
              : formik.values.data.pin.toString()
          }
          onChange={(e) => {
            if (!isNaN(Number(e.target.value)) && e.target.value.length <= 6)
              formik.setFieldValue("data.pin", Number(e.target.value));
          }}
        />
      </div>
      <div className="w-full">
        <TextField
          fullWidth
          autoComplete="off"
          type="password"
          placeholder="Konfirmasi PIN"
          label="Konfirmasi PIN"
          value={confirmPin}
          onChange={(e) => {
            if (
              !isNaN(Number(e.target.value)) &&
              !e.target.value.includes(".") &&
              e.target.value.length <= 6
            )
              setConfirmPin(e.target.value);
          }}
        />
      </div>
    </div>
  );
};

export default PinForm;
